'use client';

import { createContext } from 'react';

import type { AlertRootContextInterface } from '../types/alert-root.types';

export const AlertRootContext = createContext<AlertRootContextInterface>({});

AlertRootContext.displayName = 'Alert.Root.Context';
